module.exports = __webpack_public_path__ + "media/img/quality-illustration-0534ef29d0c741830502efdd661ed6cd.png";